import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { tuple } from '../_utils/type';
export var LinkSizes = tuple('large', 'middle', 'small');
var InternalLink = function InternalLink(props, ref) {
  var _context, _classNames, _classNames2;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls,
    userDefaultProps = _useContext.compDefaultProps;
  var linkProps = getCompProps('Link', userDefaultProps, props);
  var size = linkProps.size,
    style = linkProps.style,
    className = linkProps.className,
    target = linkProps.target,
    href = linkProps.href,
    underscore = linkProps.underscore,
    children = linkProps.children,
    prefix = linkProps.prefix,
    suffix = linkProps.suffix,
    disabled = linkProps.disabled,
    onClick = linkProps.onClick,
    customPrefixcls = linkProps.prefixCls,
    others = __rest(linkProps
    // ref
    , ["size", "style", "className", "target", "href", "underscore", "children", "prefix", "suffix", "disabled", "onClick", "prefixCls"]);
  // ref
  var linkRef = ref || /*#__PURE__*/React.createRef();
  var linkPrefixCls = getPrefixCls(prefixCls, 'link', customPrefixcls); // 按钮样式前缀
  var wrapperClasses = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(linkPrefixCls), true), _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(linkPrefixCls, "-size-")).call(_context, size), size), _classNames));
  var linkClasses = classNames(className, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(linkPrefixCls, "-text"), true), _defineProperty(_classNames2, "".concat(linkPrefixCls, "-underscore"), underscore), _defineProperty(_classNames2, "".concat(linkPrefixCls, "-disabled"), disabled), _classNames2));
  var handleClick = function handleClick(e) {
    // 禁用状态 不跳转
    disabled && e.preventDefault();
    onClick && (onClick === null || onClick === void 0 ? void 0 : onClick(e));
  };
  var prefixNode = useMemo(function () {
    return prefix ? /*#__PURE__*/React.createElement("span", {
      className: "".concat(linkPrefixCls, "-prefix")
    }, prefix) : null;
  }, [prefix, linkPrefixCls]);
  var suffixNode = useMemo(function () {
    return suffix ? /*#__PURE__*/React.createElement("span", {
      className: "".concat(linkPrefixCls, "-suffix")
    }, suffix) : null;
  }, [suffix, linkPrefixCls]);
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: wrapperClasses
  }, prefixNode, /*#__PURE__*/React.createElement("a", _extends({
    ref: linkRef,
    target: target,
    disabled: disabled,
    href: href,
    className: linkClasses,
    onClick: handleClick
  }, others), children), suffixNode);
};
var Link = /*#__PURE__*/React.forwardRef(InternalLink);
Link.displayName = 'Link';
export default Link;